"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const constants_1 = __importStar(require("../utils/constants"));
const _base_1 = require("./_base");
/**
 * ![ChevronDownIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDEyLjQxIDYuNzEiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICNmZmY7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0aXRsZT5DaGV2cm9uRG93bjwvdGl0bGU+CiAgPGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+CiAgICA8ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPgogICAgICA8cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik02LjIxLDYuNzFhLjUzLjUzLDAsMCwxLS4zNi0uMTVMLjE1Ljg1YS40OC40OCwwLDAsMSwwLS43LjQ4LjQ4LDAsMCwxLC43LDBMNi4yMSw1LjUsMTEuNTYuMTVhLjUuNSwwLDAsMSwuNzEsMCwuNS41LDAsMCwxLDAsLjdMNi41Niw2LjU2QS41MS41MSwwLDAsMSw2LjIxLDYuNzFaIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K)
 */
exports.ChevronDownIcon = (_a) => {
    var { size = 18, color } = _a, props = __rest(_a, ["size", "color"]);
    const iconColor = constants_1.expandColor(constants_1.default, color) || "currentColor";
    return (React.createElement(_base_1.Svg, Object.assign({ viewBox: "0 0 12.41 6.71", fill: iconColor, width: size, height: size, size: size, role: props.onClick ? "button" : undefined, tabIndex: props.onClick ? 0 : undefined }, props),
        React.createElement("path", { d: "M6.21 6.71a.53.53 0 0 1-.36-.15L.15.85a.48.48 0 0 1 0-.7.48.48 0 0 1 .7 0L6.21 5.5 11.56.15a.5.5 0 0 1 .71 0 .5.5 0 0 1 0 .7L6.56 6.56a.51.51 0 0 1-.35.15z" })));
};
//# sourceMappingURL=Icon.ChevronDown.js.map